import PropTypes from 'prop-types';

const financeEntity = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  orderId: PropTypes.string.isRequired,
  userInfo: PropTypes.shape({
    fullName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
  }),
  startedAt: PropTypes.string.isRequired,
  endedAt: PropTypes.string.isRequired,
  checkInTime: PropTypes.string.isRequired,
  checkOutTime: PropTypes.string.isRequired,
  totalPrice: PropTypes.number.isRequired,
  totalDiscountedPrice: PropTypes.number,
  bookingStatus: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  totalRoom: PropTypes.number.isRequired,
  nights: PropTypes.number.isRequired,
  actualAmountReceived: PropTypes.number.isRequired,
});

const invoiceEntity = PropTypes.shape({
  _id: PropTypes.string.isRequired,
  invoiceCode: PropTypes.string.isRequired,
  totalAmount: PropTypes.number,
  isPaid: PropTypes.bool,
  createdAt: PropTypes.string.isRequired,
});

const financePagination = PropTypes.shape({
  total: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(financeEntity).isRequired,
});

const invoicePagination = PropTypes.shape({
  total: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(invoiceEntity).isRequired,
});

const financeOverview = PropTypes.shape({
  totalAmountReceived: PropTypes.number.isRequired,
  totalAmountPending: PropTypes.number.isRequired,
  totalBookings: PropTypes.number.isRequired,
});

const FinancePropTypes = {
  financeEntity,
  financeOverview,
  financePagination,
  invoiceEntity,
  invoicePagination,
};

export default FinancePropTypes;
